import React from "react";
import Slider from "react-slick";

const img1 = require("../../../../assets/images/about-gehl.webp");
const img2 = require("../../../../assets/images/about-gehl.webp");
const img3 = require("../../../../assets/images/about-gehl.webp");

const settings = {
  dots: true,
  arrows: true,
  speed: 1200,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 3500,
  responsive: [
    {
      breakpoint: 1500,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};

const AboutPresentation = (props) => {
  return (
    <div className={`wpo-about-area section-padding ${props.abClass}`}>
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-5 col-md-12 col-sm-12 image-container">
            <div className="static-hero-slide-img owl-carousel">
              <Slider {...settings}>
                <div className="slide-img">
                  <img src={img1} alt="" />
                </div>
                <div className="slide-img">
                  <img src={img2} alt="" />
                </div>
                <div className="slide-img">
                  <img src={img3} alt="" />
                </div>
              </Slider>
            </div>
          </div>
          <div className="col-lg-7 col-md-12 colsm-12">
            <div className="wpo-about-text">
              <div className="wpo-about-title">
                <span>GEHL</span>
                <h3>
                  Semat, Représentant officiel de Gehl vous offre un panoplie de
                  machines
                </h3>
              </div>
              <h5>
                La société SEMAT à été crée en 2008 avec la volonté d'une équipe
                jeune et avec une vision nouvelle du métier de concessionnaire
                de matériel BTP en Tunisie
              </h5>
              <p>
                Solide, fiable, digne de confiance et travailleur. Chez Semat,
                nous savons que les machines que nous offrons sont une extension
                de vous. Nous sommes fiers de pouvoir vous offrir les meilleures
                machines. Depuis 1859, GEHL est profondément ancré dans
                l'agriculture. Créer des machines pour aider les travailleurs
                américains les plus acharnés. De nombreuses années plus tard,
                nous proposons des produits dans le monde entier qui
                fonctionnent aussi dur que les personnes qui les possèdent et
                les exploitent. S'associer avec des agriculteurs, des
                travailleurs de la construction et des paysagistes - petits et
                grands - pour aider à déplacer des montagnes et à établir une
                solide base de confiance. Nous prenons soin de nos opérateurs.
                La sécurité et les commentaires des utilisateurs finaux
                façonnent chaque machine que nous construisons pour aider nos
                opérateurs à rentrer chez eux avec leurs proches (et,
                espérons-le, même un peu plus tôt que prévu).
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutPresentation;
